import { SVGProps, Ref, forwardRef } from 'react';

export const AntennaFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m12 4.84.275.007c2.607.111 3.597 1.814 3.713 3.62L16 8.84c0 1.785-.796 3.568-3.1 3.932V24h-1.8V12.773C8.796 12.409 8 10.626 8 8.84l.012-.374C8.132 6.599 9.187 4.84 12 4.84"
                fill="currentColor"
            />
            <path
                d="m3.16 0 1.275 1.275a8 8 0 0 0-.427.468C2.487 3.57 1.8 6.108 1.8 8.841s.687 5.272 2.208 7.098q.2.239.427.466L3.16 17.68C.892 15.38 0 12.11 0 8.84l.009-.562C.107 5.198 1.02 2.167 3.159 0"
                fill="currentColor"
            />
            <path
                d="M20.838.002c2.139 2.167 3.055 5.196 3.153 8.276l.009.563c0 3.27-.892 6.54-3.161 8.839l-1.274-1.275q.226-.227.427-.467c1.521-1.825 2.208-4.365 2.208-7.097s-.687-5.272-2.208-7.098a8 8 0 0 0-.428-.468z"
                fill="currentColor"
            />
            <path
                d="m6.106 2.947 1.275 1.275q-.132.133-.248.271C6.237 5.57 5.8 7.108 5.8 8.841s.437 3.272 1.333 4.348q.116.137.248.27l-1.273 1.272C4.596 13.2 4 11.021 4 8.841l.006-.375c.065-2.054.675-4.074 2.1-5.519"
                fill="currentColor"
            />
            <path
                d="M17.892 2.948c1.426 1.445 2.037 3.464 2.102 5.518L20 8.84c0 2.18-.597 4.358-2.11 5.89l-1.272-1.272q.133-.134.25-.27c.895-1.076 1.332-2.616 1.332-4.348 0-1.733-.437-3.272-1.333-4.348a5 5 0 0 0-.249-.271z"
                fill="currentColor"
            />
        </g>
    </svg>
));
AntennaFilledSize24Glyph.displayName = 'AntennaFilledSize24Glyph';
